module.exports = __webpack_public_path__ + "media/kundenorientierung.bc0c333e.mp4";